/* ============================================================
   ARYA COLLECTION — Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ----------------------------------------------------------
     1. ANNOUNCEMENT BAR — Rotating messages
  ---------------------------------------------------------- */
  const announcementMessages = document.querySelectorAll('.announcement-bar__message');
  if (announcementMessages.length > 0) {
    let currentMsg = 0;
    announcementMessages[0].classList.add('active');

    setInterval(() => {
      announcementMessages[currentMsg].classList.remove('active');
      currentMsg = (currentMsg + 1) % announcementMessages.length;
      announcementMessages[currentMsg].classList.add('active');
    }, 3500);
  }

  /* ----------------------------------------------------------
     2. STICKY HEADER — Scroll behavior
  ---------------------------------------------------------- */
  const header = document.querySelector('.header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      if (scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = scrollY;
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     3. MOBILE MENU
  ---------------------------------------------------------- */
  const hamburger = document.querySelector('.header__hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileOverlay = document.querySelector('.mobile-menu__overlay');
  const mobileClose = document.querySelector('.mobile-menu__close');

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    if (hamburger) hamburger.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    if (hamburger) hamburger.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // Accordion in mobile menu
  document.querySelectorAll('.mobile-menu__link[data-toggle]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const submenu = link.nextElementSibling;
      if (submenu && submenu.classList.contains('mobile-menu__submenu')) {
        submenu.classList.toggle('open');
        link.classList.toggle('expanded');
      }
    });
  });

  /* ----------------------------------------------------------
     4. POPUP — Launch offer with cookie logic
  ---------------------------------------------------------- */
  const popupOverlay = document.querySelector('.popup-overlay');
  const popupClose = document.querySelector('.popup__close');
  const popupSkip = document.querySelector('.popup__skip');

  function showPopup() {
    if (popupOverlay) {
      popupOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function hidePopup() {
    if (popupOverlay) {
      popupOverlay.classList.remove('active');
      document.body.style.overflow = '';
      // Set cookie for 7 days
      const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `arya_popup_seen=true; expires=${expires}; path=/`;
    }
  }

  // Check if popup should show
  if (popupOverlay) {
    const popupSeen = document.cookie.split(';').some(c => c.trim().startsWith('arya_popup_seen='));
    if (!popupSeen) {
      setTimeout(showPopup, 3000);
    }
  }

  if (popupClose) popupClose.addEventListener('click', hidePopup);
  if (popupSkip) popupSkip.addEventListener('click', hidePopup);

  // Close on overlay click (not on popup itself)
  if (popupOverlay) {
    popupOverlay.addEventListener('click', (e) => {
      if (e.target === popupOverlay) hidePopup();
    });
  }

  // Popup form: lascia il submit nativo a Shopify, ma prima imposta il cookie
  // così al reload il popup non riappare. Il messaggio di successo è gestito
  // dal blocco liquid {% if form.posted_successfully? %} (se presente nel template).
  const popupForm = document.querySelector('.popup__form');
  if (popupForm) {
    popupForm.addEventListener('submit', () => {
      const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `arya_popup_seen=true; expires=${expires}; path=/`;
    });
  }

  /* ----------------------------------------------------------
     5. COUNTDOWN TIMER
  ---------------------------------------------------------- */
  function initCountdowns() {
    const countdowns = document.querySelectorAll('[data-countdown]');
    countdowns.forEach(el => {
      const endDate = new Date(el.dataset.countdown).getTime();

      function updateCountdown() {
        const now = Date.now();
        const diff = endDate - now;

        if (diff <= 0) {
          el.querySelectorAll('.countdown__number').forEach(n => n.textContent = '00');
          return;
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        const numbers = el.querySelectorAll('.countdown__number');
        if (numbers[0]) numbers[0].textContent = String(days).padStart(2, '0');
        if (numbers[1]) numbers[1].textContent = String(hours).padStart(2, '0');
        if (numbers[2]) numbers[2].textContent = String(minutes).padStart(2, '0');
        if (numbers[3]) numbers[3].textContent = String(seconds).padStart(2, '0');
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  }

  initCountdowns();

  /* ----------------------------------------------------------
     6. SCROLL REVEAL ANIMATIONS
  ---------------------------------------------------------- */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  function observeReveals(scope) {
    const root = scope || document;
    const els = root.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
    els.forEach(el => {
      if (!el.classList.contains('visible')) {
        revealObserver.observe(el);
      }
    });
  }

  observeReveals();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      observeReveals(e.target);
      setTimeout(() => {
        e.target.querySelectorAll('.reveal:not(.visible), .reveal-left:not(.visible), .reveal-right:not(.visible), .reveal-scale:not(.visible)').forEach(el => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            el.classList.add('visible');
          }
        });
      }, 50);
    });
  }

  /* ----------------------------------------------------------
     7. PRODUCT CARD — Image hover effect
  ---------------------------------------------------------- */
  // Handled purely via CSS :hover — no JS needed

  /* ----------------------------------------------------------
     8. (cart counter + add-to-cart toast handled by shopify.js + cart drawer)
  ---------------------------------------------------------- */

  /* ----------------------------------------------------------
     9. TOAST NOTIFICATION
  ---------------------------------------------------------- */
  function showToast(message) {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');

    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  }

  // Make showToast globally available
  window.showToast = showToast;

  /* ----------------------------------------------------------
     10. SEARCH TOGGLE
  ---------------------------------------------------------- */
  const searchBtns = document.querySelectorAll('[data-search-toggle]');
  searchBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      // Simple: focus on mobile menu search if mobile, otherwise show a search overlay
      if (window.innerWidth <= 1024) {
        openMobileMenu();
        const searchInput = document.querySelector('.mobile-menu__search-input');
        if (searchInput) setTimeout(() => searchInput.focus(), 400);
      }
    });
  });

  /* ----------------------------------------------------------
     11. PRODUCT PAGE — Size selector
  ---------------------------------------------------------- */
  document.querySelectorAll('.size-option:not(.disabled)').forEach(option => {
    option.addEventListener('click', () => {
      option.closest('.size-options').querySelectorAll('.size-option').forEach(o => o.classList.remove('active'));
      option.classList.add('active');
    });
  });

  /* ----------------------------------------------------------
     12. PRODUCT PAGE — Color selector
  ---------------------------------------------------------- */
  document.querySelectorAll('.color-option').forEach(option => {
    option.addEventListener('click', () => {
      option.closest('.color-options').querySelectorAll('.color-option').forEach(o => o.classList.remove('active'));
      option.classList.add('active');
    });
  });

  /* ----------------------------------------------------------
     13. PRODUCT PAGE — Accordion
  ---------------------------------------------------------- */
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      const wasOpen = item.classList.contains('open');

      // Close all
      item.closest('.product-accordion').querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));

      // Toggle current
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ----------------------------------------------------------
     14. CATALOG — Filters toggle (mobile)
  ---------------------------------------------------------- */
  const filtersToggle = document.querySelector('.filters-toggle');
  const filters = document.querySelector('.filters');
  if (filtersToggle && filters) {
    filtersToggle.addEventListener('click', () => {
      filters.classList.toggle('show');
      filtersToggle.textContent = filters.classList.contains('show') ? 'NASCONDI FILTRI' : 'MOSTRA FILTRI';
    });
  }

  /* ----------------------------------------------------------
     16. NEWSLETTER FORM
  ---------------------------------------------------------- */
  // Newsletter / popup — toast transiente dopo iscrizione + pulizia URL + no scroll
  if (document.querySelector('[data-form-success]')) {
    showToast('Grazie di esserti iscritto!');
    if (window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('form_type');
      url.hash = '';
      window.history.replaceState({}, '', url.pathname + (url.search ? url.search : ''));
    }
    // Forza lo scroll in cima (cancella l'anchor-jump di Shopify)
    requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'auto' }));
  } else if (document.querySelector('[data-form-error]')) {
    showToast('Qualcosa è andato storto. Riprova.');
    if (window.history.replaceState) {
      const url = new URL(window.location.href);
      url.hash = '';
      window.history.replaceState({}, '', url.pathname + (url.search ? url.search : ''));
    }
  }

  /* ----------------------------------------------------------
     17. CONTACT FORM — combina nome + cognome in contact[name] prima del submit
  ---------------------------------------------------------- */
  document.querySelectorAll('[data-contact-form]').forEach(form => {
    form.addEventListener('submit', () => {
      const firstInput = form.querySelector('[data-contact-first-name]');
      const lastInput = form.querySelector('[data-contact-last-name]');
      const fullInput = form.querySelector('[data-contact-full-name]');
      if (fullInput) {
        const first = firstInput ? firstInput.value.trim() : '';
        const last = lastInput ? lastInput.value.trim() : '';
        fullInput.value = [first, last].filter(Boolean).join(' ');
      }
    });
  });

  /* COLLECTION FILTER GROUPS — toggle open/closed */
  document.querySelectorAll('.filter-group__title').forEach(title => {
    title.addEventListener('click', () => {
      const group = title.parentElement;
      const isClosed = group.classList.toggle('filter-group--closed');
      title.setAttribute('aria-expanded', String(!isClosed));
    });
  });

  /* ----------------------------------------------------------
     19. BACK TO TOP
  ---------------------------------------------------------- */
  const backToTop = document.querySelector('.back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 600) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    }, { passive: true });

    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ----------------------------------------------------------
     20. DROPDOWN CLOSE ON OUTSIDE CLICK
  ---------------------------------------------------------- */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.header__dropdown')) {
      document.querySelectorAll('.header__dropdown-menu').forEach(menu => {
        menu.style.opacity = '';
        menu.style.visibility = '';
      });
    }
  });

  /* ----------------------------------------------------------
     21. ESCAPE KEY — Close menus/popups
  ---------------------------------------------------------- */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileMenu();
      hidePopup();
    }
  });

  /* ----------------------------------------------------------
     21b. REVIEWS SLIDER
  ---------------------------------------------------------- */
  document.querySelectorAll('[data-reviews]').forEach(section => {
    const track = section.querySelector('[data-reviews-track]');
    const prevBtn = section.querySelector('[data-reviews-prev]');
    const nextBtn = section.querySelector('[data-reviews-next]');
    const dots = section.querySelectorAll('[data-reviews-dot]');
    if (!track) return;

    const cards = Array.from(track.children);
    let current = 0;

    function visibleCount() {
      return window.innerWidth >= 768 ? 3 : 1;
    }

    function render() {
      const visible = visibleCount();
      cards.forEach((card, i) => {
        const offset = (i - current + cards.length) % cards.length;
        card.style.display = offset < visible ? '' : 'none';
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('reviews-nav__dot--active', i === current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => {
      current = (current - 1 + cards.length) % cards.length;
      render();
    });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      current = (current + 1) % cards.length;
      render();
    });
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        current = parseInt(dot.dataset.reviewsDot, 10);
        render();
      });
    });

    window.addEventListener('resize', render, { passive: true });
    render();
  });

  /* ----------------------------------------------------------
     21b. PRODUCT RECOMMENDATIONS — Async fetch
  ---------------------------------------------------------- */
  const loadRecommendations = (el) => {
    if (!el || el.dataset.recsLoaded === 'true') return;
    const url = el.getAttribute('data-section-url');
    if (!url) return;
    el.dataset.recsLoaded = 'true';
    fetch(url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('#' + el.id);
        if (fresh) {
          el.innerHTML = fresh.innerHTML;
          el.querySelectorAll('.reveal').forEach(e => e.classList.add('visible'));
          const hasCards = el.querySelector('.product-card:not(.product-card--skeleton)');
          if (!hasCards) el.style.display = 'none';
        } else {
          el.style.display = 'none';
        }
      })
      .catch(() => { el.style.display = 'none'; });
  };
  document.querySelectorAll('[data-related-products][data-section-url]').forEach(loadRecommendations);

  /* ----------------------------------------------------------
     22. SMOOTH ANCHOR LINKS
  ---------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
